export default "__VITE_ASSET__cb$zKufc__"